/**
 * @flow
 * @relayHash 5cce4135f9f67e7815a8fd6f930c7e45
 */

/* eslint-disable */

'use strict';

/*::
import type { ConcreteRequest } from 'relay-runtime';
export type DocumentStatus = "ACTIVE" | "DELETED" | "OLD" | "OLD_SAVE" | "PENDING" | "RETIRED" | "SAVED" | "SCHEDULED" | "%future added value";
export type documentChangesQueryVariables = {|
  fromPk: number,
  toPk: number,
|};
export type documentChangesQueryResponse = {|
  +documentChanges: ?{|
    +initialHtml: ?string,
    +initialDocument: ?{|
      +id: string,
      +pk: ?number,
      +name: string,
      +author: {|
        +pk: ?number,
        +userDisplay: ?string,
        +firstName: string,
        +lastName: string,
        +profile: ?{|
          +title: ?string
        |},
      |},
      +category: {|
        +pk: ?number,
        +name: string,
      |},
      +bloc: {|
        +id: string,
        +name: string,
        +tenants: ?$ReadOnlyArray<?{|
          +pk: ?number,
          +name: string,
        |}>,
      |},
      +parent: ?{|
        +id: string
      |},
      +status: ?DocumentStatus,
      +restricted: boolean,
      +effectiveDate: ?string,
      +approvalDate: ?string,
      +expirationDate: ?string,
      +revisionDate: ?string,
      +statusChangedDate: ?string,
      +originationDate: ?string,
      +legacyEffectiveDate: ?string,
      +created: ?string,
      +modified: ?any,
      +headerImageUrl: ?string,
      +rssFeedUrl: ?string,
      +rawEffectiveDate: ?string,
      +effectiveDateTimedelta: ?number,
      +attachments: ?$ReadOnlyArray<?{|
        +title: ?string,
        +fileUrl: ?string,
      |}>,
      +tags: ?$ReadOnlyArray<?{|
        +pk: ?number,
        +name: string,
      |}>,
      +approvalSignatures: ?$ReadOnlyArray<?{|
        +approver: ?{|
          +firstName: ?string,
          +lastName: ?string,
          +title: ?string,
        |},
        +proxySigner: ?{|
          +firstName: ?string,
          +lastName: ?string,
          +title: ?string,
        |},
        +approvalStep: ?{|
          +name: ?string
        |},
        +approvedDate: ?string,
      |}>,
      +pastApprovalSignatures: ?$ReadOnlyArray<?{|
        +approver: ?{|
          +firstName: ?string,
          +lastName: ?string,
          +title: ?string,
        |},
        +proxySigner: ?{|
          +firstName: ?string,
          +lastName: ?string,
          +title: ?string,
        |},
        +approvalStep: ?{|
          +name: ?string
        |},
        +approvedDate: ?string,
      |}>,
      +regulations: ?$ReadOnlyArray<?{|
        +pk: ?number,
        +name: string,
      |}>,
    |},
    +taskId: ?string,
  |}
|};
export type documentChangesQuery = {|
  variables: documentChangesQueryVariables,
  response: documentChangesQueryResponse,
|};
*/


/*
query documentChangesQuery(
  $fromPk: Int!
  $toPk: Int!
) {
  documentChanges(fromId: $fromPk, toId: $toPk) {
    initialHtml
    initialDocument {
      id
      pk
      name
      author {
        pk
        userDisplay
        firstName
        lastName
        profile {
          title
          id
        }
        id
      }
      category {
        pk
        name
        id
      }
      bloc {
        id
        name
        tenants {
          pk
          name
          id
        }
      }
      parent {
        id
      }
      status
      restricted
      effectiveDate(formatted: true)
      approvalDate(formatted: true)
      expirationDate(formatted: true)
      revisionDate(formatted: true)
      statusChangedDate
      originationDate(formatted: true)
      legacyEffectiveDate(formatted: true)
      created
      modified
      headerImageUrl
      rssFeedUrl
      rawEffectiveDate: effectiveDate
      effectiveDateTimedelta
      attachments {
        title
        fileUrl
        id
      }
      tags {
        pk
        name
        id
      }
      approvalSignatures {
        approver {
          firstName
          lastName
          title
        }
        proxySigner {
          firstName
          lastName
          title
        }
        approvalStep {
          name
          id
        }
        approvedDate(formatted: true)
      }
      pastApprovalSignatures {
        approver {
          firstName
          lastName
          title
        }
        proxySigner {
          firstName
          lastName
          title
        }
        approvalStep {
          name
          id
        }
        approvedDate(formatted: true)
      }
      regulations {
        pk
        name
        id
      }
    }
    taskId
  }
}
*/

const node/*: ConcreteRequest*/ = (function(){
var v0 = [
  {
    "kind": "LocalArgument",
    "name": "fromPk",
    "type": "Int!",
    "defaultValue": null
  },
  {
    "kind": "LocalArgument",
    "name": "toPk",
    "type": "Int!",
    "defaultValue": null
  }
],
v1 = [
  {
    "kind": "Variable",
    "name": "fromId",
    "variableName": "fromPk",
    "type": "Int!"
  },
  {
    "kind": "Variable",
    "name": "toId",
    "variableName": "toPk",
    "type": "Int!"
  }
],
v2 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "initialHtml",
  "args": null,
  "storageKey": null
},
v3 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "id",
  "args": null,
  "storageKey": null
},
v4 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "pk",
  "args": null,
  "storageKey": null
},
v5 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "name",
  "args": null,
  "storageKey": null
},
v6 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "userDisplay",
  "args": null,
  "storageKey": null
},
v7 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "firstName",
  "args": null,
  "storageKey": null
},
v8 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "lastName",
  "args": null,
  "storageKey": null
},
v9 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "title",
  "args": null,
  "storageKey": null
},
v10 = [
  v4,
  v5
],
v11 = {
  "kind": "LinkedField",
  "alias": null,
  "name": "parent",
  "storageKey": null,
  "args": null,
  "concreteType": "RLDatixDocumentType",
  "plural": false,
  "selections": [
    v3
  ]
},
v12 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "status",
  "args": null,
  "storageKey": null
},
v13 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "restricted",
  "args": null,
  "storageKey": null
},
v14 = [
  {
    "kind": "Literal",
    "name": "formatted",
    "value": true,
    "type": "Boolean"
  }
],
v15 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "effectiveDate",
  "args": v14,
  "storageKey": "effectiveDate(formatted:true)"
},
v16 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "approvalDate",
  "args": v14,
  "storageKey": "approvalDate(formatted:true)"
},
v17 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "expirationDate",
  "args": v14,
  "storageKey": "expirationDate(formatted:true)"
},
v18 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "revisionDate",
  "args": v14,
  "storageKey": "revisionDate(formatted:true)"
},
v19 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "statusChangedDate",
  "args": null,
  "storageKey": null
},
v20 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "originationDate",
  "args": v14,
  "storageKey": "originationDate(formatted:true)"
},
v21 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "legacyEffectiveDate",
  "args": v14,
  "storageKey": "legacyEffectiveDate(formatted:true)"
},
v22 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "created",
  "args": null,
  "storageKey": null
},
v23 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "modified",
  "args": null,
  "storageKey": null
},
v24 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "headerImageUrl",
  "args": null,
  "storageKey": null
},
v25 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "rssFeedUrl",
  "args": null,
  "storageKey": null
},
v26 = {
  "kind": "ScalarField",
  "alias": "rawEffectiveDate",
  "name": "effectiveDate",
  "args": null,
  "storageKey": null
},
v27 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "effectiveDateTimedelta",
  "args": null,
  "storageKey": null
},
v28 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "fileUrl",
  "args": null,
  "storageKey": null
},
v29 = [
  v7,
  v8,
  v9
],
v30 = {
  "kind": "LinkedField",
  "alias": null,
  "name": "approver",
  "storageKey": null,
  "args": null,
  "concreteType": "ApprovalSignatureApproverType",
  "plural": false,
  "selections": v29
},
v31 = {
  "kind": "LinkedField",
  "alias": null,
  "name": "proxySigner",
  "storageKey": null,
  "args": null,
  "concreteType": "ApprovalSignatureApproverType",
  "plural": false,
  "selections": v29
},
v32 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "approvedDate",
  "args": v14,
  "storageKey": "approvedDate(formatted:true)"
},
v33 = [
  v30,
  v31,
  {
    "kind": "LinkedField",
    "alias": null,
    "name": "approvalStep",
    "storageKey": null,
    "args": null,
    "concreteType": "ApprovalStepType",
    "plural": false,
    "selections": [
      v5
    ]
  },
  v32
],
v34 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "taskId",
  "args": null,
  "storageKey": null
},
v35 = [
  v4,
  v5,
  v3
],
v36 = [
  v30,
  v31,
  {
    "kind": "LinkedField",
    "alias": null,
    "name": "approvalStep",
    "storageKey": null,
    "args": null,
    "concreteType": "ApprovalStepType",
    "plural": false,
    "selections": [
      v5,
      v3
    ]
  },
  v32
];
return {
  "kind": "Request",
  "operationKind": "query",
  "name": "documentChangesQuery",
  "id": "af37afbb9f1c5fcd1294852863def87e",
  "text": null,
  "metadata": {},
  "fragment": {
    "kind": "Fragment",
    "name": "documentChangesQuery",
    "type": "Query",
    "metadata": null,
    "argumentDefinitions": v0,
    "selections": [
      {
        "kind": "LinkedField",
        "alias": null,
        "name": "documentChanges",
        "storageKey": null,
        "args": v1,
        "concreteType": "DocumentChangesType",
        "plural": false,
        "selections": [
          v2,
          {
            "kind": "LinkedField",
            "alias": null,
            "name": "initialDocument",
            "storageKey": null,
            "args": null,
            "concreteType": "DocumentType",
            "plural": false,
            "selections": [
              v3,
              v4,
              v5,
              {
                "kind": "LinkedField",
                "alias": null,
                "name": "author",
                "storageKey": null,
                "args": null,
                "concreteType": "ApprovalStepUserType",
                "plural": false,
                "selections": [
                  v4,
                  v6,
                  v7,
                  v8,
                  {
                    "kind": "LinkedField",
                    "alias": null,
                    "name": "profile",
                    "storageKey": null,
                    "args": null,
                    "concreteType": "ProfileType",
                    "plural": false,
                    "selections": [
                      v9
                    ]
                  }
                ]
              },
              {
                "kind": "LinkedField",
                "alias": null,
                "name": "category",
                "storageKey": null,
                "args": null,
                "concreteType": "CategoryType",
                "plural": false,
                "selections": v10
              },
              {
                "kind": "LinkedField",
                "alias": null,
                "name": "bloc",
                "storageKey": null,
                "args": null,
                "concreteType": "BlocType",
                "plural": false,
                "selections": [
                  v3,
                  v5,
                  {
                    "kind": "LinkedField",
                    "alias": null,
                    "name": "tenants",
                    "storageKey": null,
                    "args": null,
                    "concreteType": "TenantType",
                    "plural": true,
                    "selections": v10
                  }
                ]
              },
              v11,
              v12,
              v13,
              v15,
              v16,
              v17,
              v18,
              v19,
              v20,
              v21,
              v22,
              v23,
              v24,
              v25,
              v26,
              v27,
              {
                "kind": "LinkedField",
                "alias": null,
                "name": "attachments",
                "storageKey": null,
                "args": null,
                "concreteType": "DocumentAttachmentType",
                "plural": true,
                "selections": [
                  v9,
                  v28
                ]
              },
              {
                "kind": "LinkedField",
                "alias": null,
                "name": "tags",
                "storageKey": null,
                "args": null,
                "concreteType": "TagType",
                "plural": true,
                "selections": v10
              },
              {
                "kind": "LinkedField",
                "alias": null,
                "name": "approvalSignatures",
                "storageKey": null,
                "args": null,
                "concreteType": "ApprovalSignatureType",
                "plural": true,
                "selections": v33
              },
              {
                "kind": "LinkedField",
                "alias": null,
                "name": "pastApprovalSignatures",
                "storageKey": null,
                "args": null,
                "concreteType": "ApprovalSignatureType",
                "plural": true,
                "selections": v33
              },
              {
                "kind": "LinkedField",
                "alias": null,
                "name": "regulations",
                "storageKey": null,
                "args": null,
                "concreteType": "RegulationType",
                "plural": true,
                "selections": v10
              }
            ]
          },
          v34
        ]
      }
    ]
  },
  "operation": {
    "kind": "Operation",
    "name": "documentChangesQuery",
    "argumentDefinitions": v0,
    "selections": [
      {
        "kind": "LinkedField",
        "alias": null,
        "name": "documentChanges",
        "storageKey": null,
        "args": v1,
        "concreteType": "DocumentChangesType",
        "plural": false,
        "selections": [
          v2,
          {
            "kind": "LinkedField",
            "alias": null,
            "name": "initialDocument",
            "storageKey": null,
            "args": null,
            "concreteType": "DocumentType",
            "plural": false,
            "selections": [
              v3,
              v4,
              v5,
              {
                "kind": "LinkedField",
                "alias": null,
                "name": "author",
                "storageKey": null,
                "args": null,
                "concreteType": "ApprovalStepUserType",
                "plural": false,
                "selections": [
                  v4,
                  v6,
                  v7,
                  v8,
                  {
                    "kind": "LinkedField",
                    "alias": null,
                    "name": "profile",
                    "storageKey": null,
                    "args": null,
                    "concreteType": "ProfileType",
                    "plural": false,
                    "selections": [
                      v9,
                      v3
                    ]
                  },
                  v3
                ]
              },
              {
                "kind": "LinkedField",
                "alias": null,
                "name": "category",
                "storageKey": null,
                "args": null,
                "concreteType": "CategoryType",
                "plural": false,
                "selections": v35
              },
              {
                "kind": "LinkedField",
                "alias": null,
                "name": "bloc",
                "storageKey": null,
                "args": null,
                "concreteType": "BlocType",
                "plural": false,
                "selections": [
                  v3,
                  v5,
                  {
                    "kind": "LinkedField",
                    "alias": null,
                    "name": "tenants",
                    "storageKey": null,
                    "args": null,
                    "concreteType": "TenantType",
                    "plural": true,
                    "selections": v35
                  }
                ]
              },
              v11,
              v12,
              v13,
              v15,
              v16,
              v17,
              v18,
              v19,
              v20,
              v21,
              v22,
              v23,
              v24,
              v25,
              v26,
              v27,
              {
                "kind": "LinkedField",
                "alias": null,
                "name": "attachments",
                "storageKey": null,
                "args": null,
                "concreteType": "DocumentAttachmentType",
                "plural": true,
                "selections": [
                  v9,
                  v28,
                  v3
                ]
              },
              {
                "kind": "LinkedField",
                "alias": null,
                "name": "tags",
                "storageKey": null,
                "args": null,
                "concreteType": "TagType",
                "plural": true,
                "selections": v35
              },
              {
                "kind": "LinkedField",
                "alias": null,
                "name": "approvalSignatures",
                "storageKey": null,
                "args": null,
                "concreteType": "ApprovalSignatureType",
                "plural": true,
                "selections": v36
              },
              {
                "kind": "LinkedField",
                "alias": null,
                "name": "pastApprovalSignatures",
                "storageKey": null,
                "args": null,
                "concreteType": "ApprovalSignatureType",
                "plural": true,
                "selections": v36
              },
              {
                "kind": "LinkedField",
                "alias": null,
                "name": "regulations",
                "storageKey": null,
                "args": null,
                "concreteType": "RegulationType",
                "plural": true,
                "selections": v35
              }
            ]
          },
          v34
        ]
      }
    ]
  }
};
})();
node.text = "query documentChangesQuery(\n  $fromPk: Int!\n  $toPk: Int!\n) {\n  documentChanges(fromId: $fromPk, toId: $toPk) {\n    initialHtml\n    initialDocument {\n      id\n      pk\n      name\n      author {\n        pk\n        userDisplay\n        firstName\n        lastName\n        profile {\n          title\n          id\n        }\n        id\n      }\n      category {\n        pk\n        name\n        id\n      }\n      bloc {\n        id\n        name\n        tenants {\n          pk\n          name\n          id\n        }\n      }\n      parent {\n        id\n      }\n      status\n      restricted\n      effectiveDate(formatted: true)\n      approvalDate(formatted: true)\n      expirationDate(formatted: true)\n      revisionDate(formatted: true)\n      statusChangedDate\n      originationDate(formatted: true)\n      legacyEffectiveDate(formatted: true)\n      created\n      modified\n      headerImageUrl\n      rssFeedUrl\n      rawEffectiveDate: effectiveDate\n      effectiveDateTimedelta\n      attachments {\n        title\n        fileUrl\n        id\n      }\n      tags {\n        pk\n        name\n        id\n      }\n      approvalSignatures {\n        approver {\n          firstName\n          lastName\n          title\n        }\n        proxySigner {\n          firstName\n          lastName\n          title\n        }\n        approvalStep {\n          name\n          id\n        }\n        approvedDate(formatted: true)\n      }\n      pastApprovalSignatures {\n        approver {\n          firstName\n          lastName\n          title\n        }\n        proxySigner {\n          firstName\n          lastName\n          title\n        }\n        approvalStep {\n          name\n          id\n        }\n        approvedDate(formatted: true)\n      }\n      regulations {\n        pk\n        name\n        id\n      }\n    }\n    taskId\n  }\n}\n";
(node/*: any*/).hash = 'f929fc156696eb7e86e9ee497d071304';
module.exports = node;
